import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneInputField from "./PhoneInput";
import BaseButton from "./BaseButton";
import arrowRight from "../assets/fi_chevron-right-black.svg";
import { isValidPhoneNumber } from 'libphonenumber-js';
import CallButton from "./CallButton";
import { useAuth } from "../context/AuthContext";
import backendApi from '../services/backendApi';

function Login() {
    const [phone, setPhone] = useState('');
    const [isValid, setIsValid] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [showCallButton, setShowCallButton] = useState(false);
    const [showError, setShowError] = useState(false);
    const [invoiceProps, setInvoiceProps] = useState(null);

    const { login, user } = useAuth();
    const navigate = useNavigate();

    const handlePhoneChange = (value) => {
        setPhone(value);
        setIsValid(value?.trim() && isValidPhoneNumber(value));
    };

    if (user) {
        navigate('/');
    }

    const loginStageOne = async () => {
        setSubmitted(true);

        if (isValid) {
            try {
                const response = await backendApi.request({
                    url: '/api/call-auth',
                    method: 'POST',
                    data: { callerPhone: phone },
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: false
                });

                setShowCallButton(response.data.success)
            } catch (error) {
               // setShowCallButton(false);
            }
        } else {
            setShowCallButton(false);
        }
    };

    const loginStageTwo = async () => {
        try {
            const response = await backendApi.post('/api/login', {callerPhone: phone}, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.success) {
                const userDataResponse = await backendApi.get('/api/get-user-profile');

                if (userDataResponse.status == 200) {
                    const userData = userDataResponse.data;

                    if (userData.client) {
                        login(userData.client);
                    }

                    if (userData.invoiceProps) {
                        setInvoiceProps(userData.invoiceProps);
                    }

                    navigate('/')
                }
            } else {
                setShowError(true);
            }
        } catch (error) {
            setShowError(true);
        }
    };

    return (
        <div className="login">
            {!showCallButton && (
                <>
                    <PhoneInputField value={phone} onChange={handlePhoneChange} isValid={isValid} submitted={submitted} />
                    <BaseButton
                        className={'baseButton__login baseButton--primary'}
                        text={'Tęsti'}
                        handleOnClick={loginStageOne}
                        icon={arrowRight}
                        iconClassName={'baseButton__iconRight'}
                    />
                </>
            )}

            {showCallButton && <CallButton userPhone={phone} handleLogin={loginStageTwo} showError={showError} setShowCallButton={setShowCallButton} setPhone={setPhone} />}
        </div>
    );
}

export default Login;
